export default "__VITE_ASSET__C1k6Hjow__"